import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import Accordion from 'react-bootstrap/Accordion';

import './Definitivat.css';

export default function Definitivat() {
    return (
        <Container className="definitivatContainer worldwide">
            <p className="definitivatTitle">
                <span className="bracket">{'<'}</span>
                    Definitivat
                <span className="bracket">{'/>'}</span>
            </p>
            <p className="definitivatSubTitle">Află mai multe despre examenul de Definitivat</p>
            <Row>
                <p className="definitivatDescription">
                    Examenul de definitivare în învățământ (definitivat) pentru disciplina Informatică și TIC în România este un
                    examen național organizat de Ministerul Educației, adresat cadrelor didactice aflate la început de carieră
                    care doresc să obțină statutul de profesor cu drept de practică didactică definitivă.
                    <br/>
                    Proba scrisă evaluează atât cunoștințele de specialitate (informatică, TIC, programare, algoritmică etc.),
                    cât și competențele didactice (strategii de predare, evaluare, proiectarea lecțiilor).
                    <br/>
                    Pentru promovare, este necesară o notă minimă de 8.00. Susținerea acestui examen este obligatorie pentru
                    continuarea carierei didactice și pentru accesul ulterior la gradele didactice (gradul II și I).
                </p>
                <p className="definitivatText1">Programa Examenului de Definitivat: <a href="/definitivat/18_Programa_def_P_Informatica_si_tehnologia_informatiei.pdf" className="fixColor" target="_blank">AICI</a></p>
                <Accordion alwaysOpen defaultActiveKey={['0']}>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <span># Subiecte (2015-Prezent)</span>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="table-responsive">
                                <Table striped bordered hover size="lg" className="table-dark text-center" style={{verticalAlign: "middle"}}>
                                    <thead style={{verticalAlign: "middle"}}>
                                        <tr>
                                            <th>Anul</th>
                                            <th>Subiect</th>
                                            <th>Barem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>2026</td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2026_var_02_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2026_bar_02_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2025</td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2025_var_02_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2025_bar_02_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2024</td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2024_var_02_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2024_bar_02_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2023</td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2023_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2023_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2022</td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2022_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2022_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2021</td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2021_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2021_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2020</td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2020_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2020_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2019</td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2019_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2019_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2018</td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2018_var_02_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2018_bar_02_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2017</td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2017_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2017_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2016</td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2016_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2016_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2015</td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2015_var_02_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/definitivat/Def_050_Informatica_P_2015_bar_02_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Row>
        </Container>
    )
}